import React, { createContext, useEffect, useState } from "react";
import axios from "axios";

export const CurrentUserContext = createContext(null);

export function CurrentUserProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        axios
            .get("/api/users/current-user/")
            .then((res) => {
                setUser(res.data)
            })
            .catch(() => setUser(null))
            .finally(() => setLoading(false));
    }, []);

    if (loading) return null;               // or a spinner

    return (
        <CurrentUserContext.Provider value={user}>
            {children}
        </CurrentUserContext.Provider>
    );
}
